// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__5EoEM","tab":"ProcedureTabs_tab__30RIR"};